export default "__VITE_ASSET__Cp80qcaz__"